import React, { useState } from 'react';
import AppRouter from './components/AppRouter';
import Navbar from './components/Navbar';
import { AuthContext } from './context/AuthContext';
import { initializeApp } from 'firebase/app';

initializeApp({
  apiKey: 'AIzaSyA72JqOpEE3HeF-aqBx6abCWhr5Q_0gZvg',
  authDomain: 'crc-sim-store.firebaseapp.com',
  projectId: 'crc-sim-store',
  storageBucket: 'crc-sim-store.appspot.com',
  messagingSenderId: '17591156331',
  appId: '1:17591156331:web:5234fd1d335a2c35b43b2e',
});

const App = () => {
  const [isAuth, setIsAuth] = useState(false);

  return (
    <>
      <AuthContext.Provider value={{ isAuth }}>
        <div className="wrapper">
          <div className="container">
            <AppRouter />
          </div>
        </div>
        <Navbar />
      </AuthContext.Provider>
    </>
  );
};

export default App;
